import { LinearProgress } from '@material-ui/core';

export function LinearProgressIndicator() {
  return <LinearProgress data-testid="loading-progress" />;
}
